import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [{
  path: '/shop',
  name: 'shop',
  meta: { title: '商城' },
  redirect: '/shop/lists',
  component: Main,
  children: [
    {
      path: '/shop/lists',
      name: 'lists',
      meta: {
        title: '商城管理',
        parentPath: '/shop',
        icon: 'icon_ziti_store',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/lists',
      children: [
        {
          path: '/shop/lists',
          name: 'shop_lists',
          meta: {
            title: '商城列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/shop/lists.vue')
        },
        {
          path: '/shop/lists_detail',
          name: 'lists_detail',
          meta: {
            hidden: true,
            title: '商城信息',
            parentPath: '/shop',
            prevPath: '/shop/lists',
            permission: ['view']
          },
          component: () => import('@/views/shop/shop/lists_edit.vue')
        },
        {
          path: '/shop/modify_account',
          name: 'modify_account',
          meta: {
            hidden: true,
            title: '修改超级管理员账号',
            parentPath: '/shop',
            prevPath: '/shop/lists',
            permission: ['view']
          },
          component: () => import('@/views/shop/shop/modify_account.vue')
        },
        {
          path: '/shop/package_record',
          name: 'package_record',
          meta: {
            hidden: true,
            title: '套餐记录',
            parentPath: '/shop',
            prevPath: '/shop/lists',
            permission: ['view']
          },
          component: () => import('@/views/shop/shop/package_record.vue')
        }
      ]
    },
    {
      path: '/shop/set_meal',
      name: 'set_meal',
      meta: {
        title: '套餐管理',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/set_meal',
      children: [
        {
          path: '/shop/set_meal',
          name: 'set_meal',
          meta: {
            title: '套餐列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/set_meal/lists.vue')
        },
        {
          path: '/shop/set_meal_edit',
          name: 'set_meal_edit',
          meta: {
            hidden: true,
            title: '商城套餐',
            parentPath: '/shop',
            prevPath: '/shop/set_meal',
            permission: ['view']
          },
          component: () => import('@/views/shop/set_meal/edit.vue')
        }
      ]
    },
    {
      path: '/shop/check',
      name: 'check',
      meta: {
        title: '商户入住',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/check',
      children: [
        {
          path: '/shop/check',
          name: 'check',
          meta: {
            title: '入住列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/check/lists.vue')
        },
        {
          path: '/shop/check/edit',
          name: 'check_edit',
          meta: {
            hidden: true,
            title: '商户入住编辑',
            parentPath: '/shop',
            prevPath: '/shop/check',
            permission: ['view']
          },
          component: () => import('@/views/shop/check/edit.vue')
        }
      ]
    },
    {
      path: '/shop/IndustryRequests',
      name: 'IndustryRequests',
      meta: {
        title: '行业推广',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/IndustryRequests',
      children: [
        {
          path: '/shop/IndustryRequests',
          name: 'IndustryRequests',
          meta: {
            title: '店铺专售',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryRequests/lists.vue')
        },
        {
          path: '/IndustryRequests/lists_detail',
          name: 'lists_detail',
          meta: {
            hidden: true,
            title: '店铺专售信息',
            parentPath: '/shop',
            prevPath: '/shop/IndustryRequests',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryRequests/lists_edit.vue')
        },

        {
          path: '/shop/IndustryVideo',
          name: 'IndustryVideo',
          meta: {
            title: '行业视频',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryVideo/lists.vue')
        },
        {
          path: '/IndustryVideo/lists_detail',
          name: 'lists_detail',
          meta: {
            hidden: true,
            title: '行业视频信息',
            parentPath: '/shop',
            prevPath: '/shop/IndustryVideo',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryVideo/lists_edit.vue')
        },

        {
          path: '/shop/IndustryConsultation',
          name: 'IndustryConsultation',
          meta: {
            title: '行业资讯',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryConsultation/lists.vue')
        },
        {
          path: '/IndustryConsultation/lists_detail',
          name: 'lists_detail',
          meta: {
            hidden: true,
            title: '行业资讯信息',
            parentPath: '/shop',
            prevPath: '/shop/IndustryConsultation',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryConsultation/lists_edit.vue')
        },
        {
          path: '/shop/IndustryPromotion',
          name: 'IndustryPromotion',
          meta: {
            title: '行业展会',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryPromotion/lists.vue')
        },
        {
          path: '/IndustryPromotion/lists_detail',
          name: 'lists_detail',
          meta: {
            hidden: true,
            title: '行业展会信息',
            parentPath: '/shop',
            prevPath: '/shop/IndustryPromotion',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryPromotion/lists_edit.vue')
        },
        {
          path: '/shop/IndustryShop',
          name: 'IndustryShop',
          meta: {
            title: '行业商户',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryShop/lists.vue')
        },
        {
          path: '/IndustryShop/lists_detail',
          name: 'lists_detail',
          meta: {
            hidden: true,
            title: '行业商户信息',
            parentPath: '/shop',
            prevPath: '/shop/IndustryShop',
            permission: ['view']
          },
          component: () => import('@/views/shop/IndustryShop/lists_edit.vue')
        }


      ]
    },
    {
      path: '/shop/promotionModule',
      name: 'promotionModule',
      meta: {
        title: '推广模块',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/promotionModule',
      children: [
        {
          path: '/shop/promotionModule',
          name: 'promotionModule',
          meta: {
            title: '推广模块右列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/promotionModule/lists.vue')
        },
        {
          path: '/shop/promotionModule/edit',
          name: 'promotionModule_edit',
          meta: {
            hidden: true,
            title: '推广模块右编辑',
            parentPath: '/shop',
            prevPath: '/shop/promotionModule',
            permission: ['view']
          },
          component: () => import('@/views/shop/promotionModule/edit.vue')
        },
        {
          path: '/shop/promotionModule1',
          name: 'promotionModule1',
          meta: {
            title: '推广模块左列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/promotionModule1/lists.vue')
        },
        {
          path: '/shop/promotionModule1/edit',
          name: 'promotionModule_edit1',
          meta: {
            hidden: true,
            title: '推广模块左编辑',
            parentPath: '/shop',
            prevPath: '/shop/promotionModule1',
            permission: ['view']
          },
          component: () => import('@/views/shop/promotionModule1/edit.vue')
        }

      ]
    },
    {
      path: '/shop/video',
      name: 'video',
      meta: {
        title: '视频模块',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/video',
      children: [
        {
          path: '/shop/video',
          name: 'video',
          meta: {
            title: '视频列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/video/lists.vue')
        },
        {
          path: '/shop/video/edit',
          name: 'video_edit',
          meta: {
            hidden: true,
            title: '视频编辑',
            parentPath: '/shop',
            prevPath: '/shop/video',
            permission: ['view']
          },
          component: () => import('@/views/shop/video/edit.vue')
        }
      ]
    },
    {
      path: '/shop/news',
      name: 'news',
      meta: {
        title: '资讯模块',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/news',
      children: [
        {
          path: '/shop/news',
          name: 'news',
          meta: {
            title: '资讯列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/news/lists.vue')
        },
        {
          path: '/shop/news/edit',
          name: 'news_edit',
          meta: {
            hidden: true,
            title: '资讯编辑',
            parentPath: '/shop',
            prevPath: '/shop/news',
            permission: ['view']
          },
          component: () => import('@/views/shop/news/edit.vue')
        }
      ]
    },
    {
      path: '/shop/article',
      name: 'article',
      meta: {
        title: '新闻资讯',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/article',
      children: [
        {
          path: '/shop/article',
          name: 'article',
          meta: {
            title: '资讯列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/article/lists.vue')
        },
        {
          path: '/shop/article/edit',
          name: 'article_edit',
          meta: {
            hidden: true,
            title: '资讯编辑',
            parentPath: '/shop',
            prevPath: '/shop/article',
            permission: ['view']
          },
          component: () => import('@/views/shop/article/edit.vue')
        },
        {
          path: '/shop/article_category',
          name: 'article_category',
          meta: {
            title: '资讯分类',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/article_category/lists.vue')
        },
        {
          path: '/shop/article_category/edit',
          name: 'article_category_edit',
          meta: {
            hidden: true,
            title: '资讯分类编辑',
            parentPath: '/shop',
            prevPath: '/shop/article_category',
            permission: ['view']
          },
          component: () => import('@/views/shop/article_category/edit.vue')
        }
      ]
    },

    {
      path: '/shop/collection',
      name: 'collection',
      meta: {
        title: '采集商品分类',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/collection',
      children: [
        {
          path: '/shop/collection',
          name: 'collection',
          meta: {
            title: '采集分类列表',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/collection/lists.vue')
        },
        {
          path: '/shop/collection/edit',
          name: 'collection_edit',
          meta: {
            hidden: true,
            title: '采集分类编辑',
            parentPath: '/shop',
            prevPath: '/shop/collection',
            permission: ['view']
          },
          component: () => import('@/views/shop/collection/edit.vue')
        }
      ]
    },
    {
      path: '/shop/video1',
      name: 'video',
      meta: {
        title: 'ai视频',
        parentPath: '/shop',
        icon: 'icon_order_guanli',
        permission: ['view']
      },
      component: Blank,
      redirect: '/shop/video1',
      children: [
        {
          path: '/shop/video1',
          name: 'video',
          meta: {
            title: 'ai视频',
            parentPath: '/shop',
            permission: ['view']
          },
          component: () => import('@/views/shop/shop/video.vue')
        },
        {
          path: '/shop/video1/edit',
          name: 'video_edit',
          meta: {
            hidden: true,
            title: 'ai视频',
            parentPath: '/shop',
            prevPath: '/shop/video1',
            permission: ['view']
          },
          component: () => import('@/views/shop/shop/video_detail.vue')
        }
      ]
    },

    // {
    //   path: '/shop/pcai_video',
    //   name: 'pcai_video',
    //   meta: {
    //     title: 'pcai视频',
    //     parentPath: '/shop',
    //     icon: 'icon_order_guanli',
    //     permission: ['view']
    //   },
    //   component: Blank,
    //   redirect: '/shop/pcai_video',
    //   children: [
    //     {
    //       path: '/shop/pcai_video',
    //       name: 'pcai_video',
    //       meta: {
    //         title: 'pcai视频',
    //         parentPath: '/shop',
    //         permission: ['view']
    //       },
    //       component: () => import('@/views/shop/pcai_video/lists.vue')
    //     },
    //     {
    //       path: '/shop/pcai_video/edit',
    //       name: 'pcai_video_edit',
    //       meta: {
    //         hidden: true,
    //         title: 'pcai视频',
    //         parentPath: '/shop',
    //         prevPath: '/shop/pcai_video',
    //         permission: ['view']
    //       },
    //       component: () => import('@/views/shop/pcai_video/edit.vue')
    //     }
    //   ]
    // },
    //
    // {
    //   path: '/shop/pcai_video_category',
    //   name: 'pcai_video_category',
    //   meta: {
    //     title: 'pcai视频分类',
    //     parentPath: '/shop',
    //     icon: 'icon_order_guanli',
    //     permission: ['view']
    //   },
    //   component: Blank,
    //   redirect: '/shop/pcai_video_category',
    //   children: [
    //     {
    //       path: '/shop/pcai_video_category',
    //       name: 'pcai_video_category',
    //       meta: {
    //         title: 'pcai视频分类',
    //         parentPath: '/shop',
    //         permission: ['view']
    //       },
    //       component: () => import('@/views/shop/pcai_video_category/lists.vue')
    //     },
    //     {
    //       path: '/shop/pcai_video_category/edit',
    //       name: 'pcai_video_category_edit',
    //       meta: {
    //         hidden: true,
    //         title: 'pcai视频分类',
    //         parentPath: '/shop',
    //         prevPath: '/shop/pcai_video_category',
    //         permission: ['view']
    //       },
    //       component: () => import('@/views/shop/pcai_video_category/edit.vue')
    //     }
    //   ]
    // },

    //   {
    //   path: '/shop/IndustryVideo',
    //   name: 'IndustryVideo',
    //   meta: {
    //     title: '行业视频',
    //     parentPath: '/shop',
    //     icon: 'icon_order_guanli',
    //     permission: ['view']
    //   },
    //   component: Blank,
    //   redirect: '/shop/IndustryVideo',
    //   children: [
    //     {
    //       path: '/shop/IndustryVideo',
    //       name: 'IndustryVideo',
    //       meta: {
    //         title: '行业视频列表',
    //         parentPath: '/shop',
    //         permission: ['view']
    //       },
    //       component: () => import('@/views/shop/IndustryVideo/lists.vue')
    //     },
    //     {
    //       path: '/IndustryVideo/lists_detail',
    //       name: 'lists_detail',
    //       meta: {
    //         hidden: true,
    //         title: '行业视频信息',
    //         parentPath: '/shop',
    //         prevPath: '/shop/IndustryVideo',
    //         permission: ['view']
    //       },
    //       component: () => import('@/views/shop/IndustryVideo/lists_edit.vue')
    //     }
    //   ]
    // }
  ]
}]

export default routes
